import { Alert } from 'antd'
import { InfoCircleFilled } from '@ant-design/icons'
import { ModalQuestionIco } from '@modules/CustomIcons'
import { useCustomModal } from '@shared/Modal'
import { t } from 'i18next'
import CustomResult from 'pages/BusinessCards/components/LimitsPage/utils/CustomResult'
import React, { useEffect, useState } from 'react'
import {
  useFetchCardBlockUpdateMutation,
  useFetchCheckCardMutation,
  useFetchByDocTypeMutation,
  limitsCardApi,
} from 'store/reducers/limitsforBusinnesCard/cardLimits.api'
import { ActionStatus } from '../../../constants/constantForLimits'
import { QueryStatus } from '@reduxjs/toolkit/query'
import {
  arrayBufferToBase64,
  AsanSigning,
  CompleteData,
} from '@shared/AsanSigning'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '@shared/hooks/useAppSelector'
import { secureLocalStorageGet } from '@app/helpers'

function CardBlockConfirm({ data }: { data: any }) {
  const { closeModal, open, setStatus } = useCustomModal()
  const isNotBlocked = !data?.generInfo?.isBlocked
  const dispatch = useDispatch()
  const pan = useAppSelector((state) => state.employeePan.pan)

  const [asanOpen, setAsanOpen] = useState(false)
  const [fetchCheckCard] = useFetchCheckCardMutation({
    fixedCacheKey: 'FetchCheckCardMutation',
  })
  const [fetchCardBlockUpdate, { status: fcbuStatus, reset, isSuccess }] =
    useFetchCardBlockUpdateMutation()

  function statusReset() {
    if (isSuccess) {
      dispatch(limitsCardApi.util.resetApiState())
    }
    reset()
  }
  const authType = secureLocalStorageGet('channel')
  const operation = {
    updateRequestData: {
      pan: data?.generInfo?.pan,
      isDirector: isNotBlocked ? null : true,
      operationType: isNotBlocked
        ? ActionStatus.BLOCKING
        : ActionStatus.UNBLOCKING,
      cif: data?.generInfo?.cif,
    },
    blockCard: function ({ transactionId }: CompleteData) {
      fetchCardBlockUpdate({
        updateRequestData: { ...this.updateRequestData, transactionId },
      })
        .unwrap()
        .then(() => {
          setStatus({
            status: QueryStatus.fulfilled,
            message: t('businessCards.operationSuccessNote'),
          })
        })
        .catch((err) =>
          setStatus({ status: QueryStatus.rejected, message: err?.data })
        )
    },
  }

  const getUserAccessCheck = () => {
    const requestData = {
      pan: data?.generInfo?.pan,
      cardHolderCif: data?.generInfo?.cardHolderCif,
      currentStatusType: data?.generInfo?.currentStatusType,
      cif: data?.generInfo?.cif,
      operationType: isNotBlocked
        ? ActionStatus.BLOCKING
        : ActionStatus.UNBLOCKING,
    }

    setStatus({ status: QueryStatus.pending })
    fetchCheckCard({ requestData })
      .unwrap()
      .then((res) => {
        if (res?.startBlockUpd && !res?.startDirectorByDocType) {
          operation.blockCard({
            transactionId: null,
          })
        } else if (
          !isNotBlocked &&
          !res?.startBlockUpd &&
          res?.startDirectorByDocType
        ) {
          closeModal()
          setAsanOpen(true)
        }
      })
      .catch((error) => {
        setStatus({ status: QueryStatus.rejected, message: error?.data })
      })
  }

  useEffect(() => {
    if (!open) {
      reset()
    }
  }, [open])

  return (
    <>
      <AsanSigning
        asanKey="LMT"
        docType="LMT"
        checkSignCallback={() => true}
        checkDirectorFnWithProps={[
          useFetchByDocTypeMutation,
          {
            isClickCardBlockButton: true,
            docType: 'LMT',
          },
        ]}
        defaultOpen={[asanOpen, setAsanOpen]}
        onComplete={(complateData) => operation.blockCard(complateData)}
        status={fcbuStatus}
        handleSigning={() => ({
          files: [
            {
              name: `biznes_kart_${moment().format('DD.MM.YYYY')}.json`,
              mimeType: 'application/json',
              encodedBytes: arrayBufferToBase64(operation.updateRequestData),
            },
          ],
        })}
        afterCloseFn={statusReset}
      />
      <CustomResult
        icon={<ModalQuestionIco />}
        text={
          isNotBlocked
            ? t('businessCards.sureBlockedCard')
            : t('businessCards.sureUnblockedCard')
        }
        info={
          authType === 'ASAN' && isNotBlocked ? (
            <Alert
              type="info"
              showIcon
              icon={<InfoCircleFilled style={{ color: '#7b61ff' }} />}
              style={{
                marginTop: 12,
                textAlign: 'start',
                backgroundColor: '#f1eefc',
                borderColor: '#f1eefc',
                borderRadius: '8px',
              }}
              message={
                <span style={{ color: '#7b61ff' }}>
                  {t('businessCards.asanBlockInfo')}
                </span>
              }
            />
          ) : null
        }
        buttons={[
          {
            label: t('home.no'),
            type: 'default',
            onClick: closeModal,
          },
          {
            label: t('home.yes'),
            type: 'primary',
            onClick: () => getUserAccessCheck(),
          },
        ]}
      />
    </>
  )
}

export default CardBlockConfirm
